import { BaseParser } from 'app/services/api/parsers/base-parser';
import { ServerResponseData } from 'app/models/api/response';
import { ParserMap } from 'app/services/api/parsers/response-parser';
import { Conversation } from 'app/models/api/conversation';

export class ConversationParser extends BaseParser {
    parse(data: ServerResponseData, included: ServerResponseData[], parsersMap: ParserMap) {
        const item = super.parseBase(Conversation, data);
        item.chatPartner = this.getRelationship('chatPartner', data, included, parsersMap);
        item.lastMessage = this.getRelationship('lastMessage', data, included, parsersMap);
        return item;
    }
}
